import ViewHeader, { useViewHeaderStore } from './ViewHeader';

export default ViewHeader;
export { useViewHeaderStore };
